"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-top-right-radius: ", ";\n  border-bottom-left-radius: ", ";\n  background: ", ";\n  color: ", ";\n  font-size: calc(", " * 0.9);\n  padding: 0.75em;\n  position: absolute;\n  top: 0;\n  right: 0;\n  > * {\n    display: block;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-top-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  background: ", ";\n  color: ", ";\n  font-size: calc(", " * 0.9);\n  padding: 0.75em;\n  position: absolute;\n  top: 0;\n  left: 0;\n  > * {\n    display: block;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopLeftIconContainer = exports.TopRightIcon = void 0;

var web_1 = require("@thesisedu/web");

var polished_1 = require("polished");

var react_1 = __importDefault(require("react"));

function TopRightIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '@gray-7' : _ref$color,
      icon = _ref.icon,
      tooltip = _ref.tooltip;
  var content = react_1.default.createElement(TopRightIconContainer, {
    color: color
  }, icon);

  if (tooltip) {
    return react_1.default.createElement(web_1.Tooltip, {
      title: tooltip,
      children: content
    });
  } else return content;
}

exports.TopRightIcon = TopRightIcon;
exports.TopLeftIconContainer = web_1.styled.div(_templateObject(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return (0, polished_1.transparentize)(0.25, props.theme['@gray-7']);
}, function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@size-s'];
});
var TopRightIconContainer = web_1.styled.div(_templateObject2(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return (0, polished_1.transparentize)(0.25, props.theme[props.color]);
}, function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@size-s'];
});